import AuthenticationForm from './AuthenticationForm';

export default AuthenticationForm;
